import { Tooltip, centsToUnits, getPaymentProcessorTitle } from '@systemeio/ui'
import { ContactPaymentsStatus } from 'modules/contacts/contact-page/enums/contact-payments-enum'
import { ContactPaymentsInterface } from 'modules/contacts/contact-page/types/contact-payments-interface'
import React from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import useUser from 'shared/hooks/use-user'
import { currencyFormat } from 'shared/utils/currency-format'

interface ContactPaymentsAmountTooltipProps {
  contactPayment: ContactPaymentsInterface
}

const ContactPaymentsAmountTooltip = ({ contactPayment }: ContactPaymentsAmountTooltipProps) => {
  const { t } = useLocoTranslation()
  const { user } = useUser()
  const pricePlan = contactPayment.paymentItems[0].orderItem.pricePlan
  const productOrderItem = contactPayment.paymentItems[0].orderItem.productOrderItem
  const tax = centsToUnits(contactPayment.tax)

  return (
    <Tooltip
      mode="hover"
      className="w-full max-w-fit truncate"
      wrapperClassName={'w-full'}
      label={
        <div className="flex flex-col items-start gap-2">
          <p>
            {currencyFormat(
              centsToUnits(contactPayment.total),
              contactPayment.currency,
              user?.dashboardLocale,
            )}{' '}
            {t('dashboard.contact_page.transaction_for').toLowerCase()}{' '}
            <span className="font-bold">
              {pricePlan ? pricePlan.innerName : productOrderItem && productOrderItem.product.name}
            </span>
          </p>
          <p>
            <span className="text-text-primary font-bold">{t('global.status')}: </span>
            {t(ContactPaymentsStatus[contactPayment.status])}
          </p>
          <p>
            <span className="text-text-primary font-bold">
              {t('dashboard.contact_page.transaction_vat')}:{' '}
            </span>
            {currencyFormat(tax, contactPayment.currency, user?.dashboardLocale)}
          </p>
          <p>
            <span className="text-text-primary font-bold">
              {t('dashboard.contact_page.payment_processor')}:{' '}
            </span>
            {getPaymentProcessorTitle(contactPayment.paymentProcessorName)}
          </p>
        </div>
      }
    >
      <div className="cursor-default truncate">
        <span>
          {currencyFormat(
            centsToUnits(contactPayment.total),
            contactPayment.currency,
            user?.dashboardLocale,
          )}
        </span>
      </div>
    </Tooltip>
  )
}

export default ContactPaymentsAmountTooltip
